import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../../utils/global_const";
import { ProductContext } from "../../context/ProductContext";
import Header from "../../layouts/header/Header";
import NewArrivalsMain from "../../layouts/main/product/NewArrivalsMain";

const SEOConfig = {
  en: {
    title: "New Arrivals | Wholesale Nicotine Pouches – B2B SnusCo",
    description:
      "Be the first to stock our latest nicotine pouches—carefully selected for premium quality, exciting new flavors, and bulk availability. Perfect for tobacco shops across Europe, with a special focus on Austria!",
    keywords:
      "snusco, b2b snusco, wholesale new arrivals, bulk nicotine pouches, tobacco shop supplies, new nicotine pouches Europe",
    url: "https://b2b.snusco.at/en/new-arrivals",
    images: ["https://b2b.snusco.at/assets/new-arrivals-category-image.jpg"],
  },
  de: {
    title: "Neuheiten | Großhandel Nikotintaschen – B2B SnusCo GmbH",
    description:
      "Seien Sie zuerst mit unseren neuesten Nikotintaschen im Großhandel ausgestattet—ausgewählt für Premiumqualität, spannende neue Aromen und große Verfügbarkeit. Ideal für Tabakgeschäfte in ganz Europa, mit Schwerpunkt auf Österreich!",
    keywords:
      "snusco, b2b snusco, Großhandel Neuheiten, Bulk Nikotintaschen, Tabakladenbedarf, neue Nikotintaschen Europa",
    url: "https://b2b.snusco.at/de/neuheiten",
    images: ["https://b2b.snusco.at/assets/new-arrivals-category-image.jpg"],
  },
};

const NewArrivals = () => {
  const { t, i18n } = useTranslation();
  const { loadNewArrivalsProducts, featuredProducts } =
    useContext(ProductContext);

  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    if (!initialLoad) {
      // Proverava da li je ovo prvi put da se učitava
      loadNewArrivalsProducts();
      setInitialLoad(true); // Postavlja da je inicijalno učitavanje završeno
    }
  }, [initialLoad]);

  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <NewArrivalsMain />
      <Footer />
    </div>
  );
};

export default NewArrivals;
